
<div class="col-md-12" style="box-shadow: 3px 3px 33px 6px #7500C0; height: 35vw;background: linear-gradient(141deg, #fafafa 20%, #fafafa 65%);">

<div class="row">
    <div class="col-sm-12">
  <div class="column col-sm-6">
    <img alt="Antilocker" src="../assets/img/Dashboard.png" style="width:100%" class="block">
  </div>
  <div class="column col-sm-6" style="font-weight: bold;margin-top: 50px; text-align: justify;">
    <div style="font-size: 16px;">Call Accounting Portal is a centralized web-based Call Reporting Application for Microsoft Teams and CISCO IP Telephony ,which is currently hosted in Frankfurt PIC. There is a separate dedicated instance for India region. This application is being developed in a way that it can act as a billing and reporting tool for CDL (formerly known as GDN) and will be used as a reporting only tool for rest of the globe Accenture locations.</div>
  </div>
 
</div>
</div>
</div>